export default "__VITE_ASSET__DaSXCicb__"